var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F1F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 10.9997L13.0001 4.92844C13.0001 4.37549 12.5532 3.9286 12.0002 3.9286C11.4473 3.9286 11.0004 4.37549 11.0004 4.92844L11.0004 10.9997L4.92915 10.9997C4.3762 10.9997 3.92931 11.4466 3.92931 11.9995C3.92931 12.5525 4.3762 12.9994 4.92915 12.9994L11.0004 12.9994L11.0004 19.0706C11.0004 19.6235 11.4473 20.0704 12.0002 20.0704C12.276 20.0704 12.5263 19.9587 12.7073 19.7777C12.8883 19.5967 13.0001 19.3464 13.0001 19.0706L13.0001 12.9994L19.0713 12.9994C19.3471 12.9994 19.5974 12.8876 19.7784 12.7066C19.9594 12.5256 20.0711 12.2753 20.0711 11.9995C20.0711 11.4466 19.6242 10.9997 19.0713 10.9997L13.0001 10.9997Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.89759a9f757a259cc182ec2d67e2c8f2.svg";
export { ForwardRef as ReactComponent };